var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M3.516,2.5,9.79-3.774A.714.714,0,0,0,10-4.282a.714.714,0,0,0-.21-.508A.714.714,0,0,0,9.282-5a.714.714,0,0,0-.508.21L2.5,1.484-3.774-4.79A.714.714,0,0,0-4.282-5a.714.714,0,0,0-.508.21A.714.714,0,0,0-5-4.282a.714.714,0,0,0,.21.508L1.484,2.5-4.79,8.774A.714.714,0,0,0-5,9.282a.714.714,0,0,0,.21.508.714.714,0,0,0,.508.21.714.714,0,0,0,.508-.21L2.5,3.516,8.774,9.79A.718.718,0,1,0,9.79,8.774Z",
    transform: "translate(5 5)",
    fill: "#0f1c21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.34feb3b75c54af4a119465da5ebe3b16.svg";
export { ForwardRef as ReactComponent };